import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Trash2 } from 'lucide-react';
import MediaUploadWithMeta from '@/components/admin/MediaUploadWithMeta';

const projectFilters = ['Residenziale', 'Commerciale', 'In Progress', 'Outdoor'];

export default function CategoryEditor({ initialValue, onSave, onDelete, saving, isNew }) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState('');

  const save = () => {
    const mediaUrl = (value.media_type || 'image') === 'video' ? value.video_url : value.image;
    if (!value.name?.trim() || !mediaUrl || !value.image_meta?.title?.trim() || !value.image_meta?.description?.trim()) {
      setError('Inserisci nome, contenuto, titolo SEO e descrizione SEO.');
      return;
    }
    setError('');
    onSave({ ...value, name: value.name.trim(), media_type: value.media_type || 'image', order: Number(value.order) || 0 });
  };

  return (
    <Card>
      <CardHeader className="flex-row items-center justify-between">
        <CardTitle className="text-lg">{isNew ? 'Nuova categoria' : value.name}</CardTitle>
        {!isNew && <Button type="button" variant="ghost" size="icon" onClick={onDelete} aria-label={`Elimina ${value.name}`}><Trash2 className="text-red-500" /></Button>}
      </CardHeader>
      <CardContent className="space-y-5">
        <div className="grid gap-4 md:grid-cols-3">
          <div><Label>Nome categoria</Label><Input value={value.name || ''} onChange={(e) => setValue({ ...value, name: e.target.value })} /></div>
          <div><Label>Progetti collegati</Label><select className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm" value={value.filter || 'Residenziale'} onChange={(e) => setValue({ ...value, filter: e.target.value })}>{projectFilters.map(filter => <option key={filter}>{filter}</option>)}</select></div>
          <div><Label>Ordine</Label><Input type="number" min="0" value={value.order ?? 0} onChange={(e) => setValue({ ...value, order: e.target.value })} /></div>
        </div>
        <MediaUploadWithMeta type={value.media_type || 'image'} url={(value.media_type || 'image') === 'video' ? value.video_url || '' : value.image || ''} meta={value.image_meta || {}} label="Contenuto categoria e dati SEO" fieldId={`category-${initialValue.id || 'new'}`} onTypeChange={(media_type) => setValue({ ...value, media_type })} onChange={(url) => setValue((value.media_type || 'image') === 'video' ? { ...value, video_url: url } : { ...value, image: url })} onMetaChange={(image_meta) => setValue({ ...value, image_meta })} />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <Button type="button" onClick={save} disabled={saving}>{saving ? 'Salvataggio...' : isNew ? 'Aggiungi categoria' : 'Salva modifiche'}</Button>
      </CardContent>
    </Card>
  );
}